import React, { useState } from 'react';
import { useClassName } from 'common/hooks';
import { ContentfulRichText } from 'common/components';
import useCustomStyle from '../../hooks';

import './faqs.less';

export default function Faqs({ component }) {
  const [style] = useCustomStyle(component.fields.settings);
  const pageSize = parseInt(style['--page-size']) || 7;
  const [showAll, setShowAll] = useState(false);
  const [openFaq, setOpenFaq] = useState(-1);
  const classNames = useClassName('CLPFaqs');

  const handleShowAnswer = (index) => {
    if (index !== openFaq) return setOpenFaq(index);
    setOpenFaq(-1);
  };

  const faqsToShow = showAll
    ? component.fields.faqs
    : component.fields.faqs.slice(0, pageSize);

  return (
    <div
      className={classNames(['container', component.fields.theme || 'light'])}>
      <div className={classNames('content')}>
        <div className={classNames('title')}>{component.fields.title}</div>
        <div className={classNames('description')}>
          <ContentfulRichText
            field={{ 'en-US': component.fields.description }}
          />
        </div>
      </div>
      <div className={classNames('faqs', showAll ? 'expanded' : 'collapsed')}>
        {faqsToShow.map((faq, index) => (
          <div
            key={`faq-${index}`}
            className={classNames(
              'faq-container',
              openFaq === index ? 'open' : 'closed'
            )}
            onClick={() => handleShowAnswer(index)}>
            <div className={classNames('faq')}>
              <p className={classNames('faq-text')}>{faq.fields.key}</p>
              <button
                onClick={() => handleShowAnswer(index)}
                className={classNames(
                  'show-btn',
                  component.fields.theme || 'light'
                )}>
                {openFaq === index ? '-' : '+'}
              </button>
            </div>
            <div
              className={classNames(
                'answer',
                openFaq === index ? 'visible' : 'hidden'
              )}>
              <ContentfulRichText
                field={{ 'en-US': faq.fields.richTextValue }}
              />
            </div>
          </div>
        ))}
        <button
          onClick={() => setShowAll((prev) => !prev)}
          className={classNames(
            'show-more-btn',
            component.fields.theme || 'light'
          )}>
          Show {showAll ? 'less' : 'more'}
        </button>
      </div>
    </div>
  );
}
